import React from "react";
import { BarChart, LineChart, Layers } from "lucide-react"; // Changed icons

const FinalValuationEstimate = () => {
  return (
    <div className="w-full p-6 bg-white shadow-md rounded-lg">
      {/* Heading */}
      <h2 className="text-lg font-medium text-gray-900 mb-2">
        Final Valuation Estimate
      </h2>

      {/* Valuation Explanation */}
      <p className="mb-6 text-gray-700">
        Based on the three approaches, the estimated valuation of GoFood is summarized below:
      </p>

      {/* Valuation Table */}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100 text-gray-700">
              <th className="border p-3 text-left text-lg font-semibold">Approach</th>
              <th className="border p-3 text-left text-lg font-semibold">Estimated Value</th>
            </tr>
          </thead>
          <tbody>
            <tr className="hover:bg-gray-50">
              <td className="border p-3 flex items-center">
                <BarChart className="mr-3 text-blue-600" />
                <span>Market Approach</span>
              </td>
              <td className="border p-3 font-medium">$4,680,000 - $5,175,000</td>
            </tr>
            <tr className="hover:bg-gray-50">
              <td className="border p-3 flex items-center">
                <Layers className="mr-3 text-green-600" />
                <span>Asset-Based Approach</span>
              </td>
              <td className="border p-3 font-medium">$1,360,000</td>
            </tr>
            <tr className="hover:bg-gray-50">
              <td className="border p-3 flex items-center">
                <LineChart className="mr-3 text-purple-600" />
                <span>Income Approach (DCF)</span>
              </td>
              <td className="border p-3 font-medium">$5,250,000</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Final Valuation Summary */}
      <div className="mt-6">
        <p className="text-lg font-medium text-gray-900 mb-2">
          Final Estimated Business Value:
        </p>
        <p className="text-gray-800 text-lg mb-4">
          After considering all approaches, the most reasonable valuation range for GoFood is
          <strong> $4.8M - $5.2M</strong>, with a midpoint of <strong>$5,000,000</strong>.
        </p>
      </div>

      {/* Conclusion & Recommendations */}
      <h3 className="text-lg font-medium text-gray-900 mb-3">Conclusion & Recommendations</h3>
      <ul className="list-disc pl-5 text-gray-700 space-y-2">
        <li>
          <strong>For Investors:</strong> GoFood has strong growth and cash flow, making it an attractive acquisition.
        </li>
        <li>
          <strong>For Strategic Buyers:</strong> Expansion and stable revenue offer long-term potential.
        </li>
        <li>
          <strong>For Internal Use:</strong> This valuation can help secure financing, attract investors, or plan an exit strategy.
        </li>
      </ul>

      {/* Final Business Valuation */}
      <p className="font-semibold text-lg mt-6">
        GoFood's estimated business valuation as of 2024 is{" "}
        <span className="text-blue-600 font-bold">$5,000,000</span>.
      </p>
    </div>
  );
};

export default FinalValuationEstimate;
